module.exports = __webpack_public_path__ + "img/newEmptyAnalysis.262cf4dd.svg";